import React, { useState } from 'react';
import { Identificacion } from '../form';
import { useFormik } from 'formik';
import * as yup from "yup";
import { Grid } from '@mui/material';
import { Button } from 'components';
import { MerchantBOIdentidadUpd } from 'services/hooli-services/MerchantBOIdentidadUpd';
import { userCredentials } from 'recoilState/GlobalState';
import { useRecoilValue } from 'recoil';
import axios from 'axios';
import { MerchantBOFilesDo } from 'services/hooli-services/MerchantBoFilesDo';
import { DocumentosPut } from 'services/hooli-services/DocumentosPut';
import { DropZone } from 'components/DropZone';

export function ContainerIdentificacion({ merchantInfo, load, setLoad, setModalDetails, modalDetails, location }) {
    const credentials = useRecoilValue(userCredentials);
    const [updFile, setUpdFile] = useState(false);
    const [file, setFile] = useState(null)
    console.log(merchantInfo)
    const handleClickUpd = async (values) => {
        setLoad(true);
        const response = await MerchantBOIdentidadUpd(credentials, values, location);
        // console.log("Response", response);
        setLoad(false);
        setModalDetails({ ...modalDetails, isOpen: false })
    }
    const validationSchema = yup.object({
        nombre: yup.string().required("Debes ingresar tu nombre"),
        tipoDeSociedad: merchantInfo.merchantPFPJ === "J" ? yup.number().required("Debes seleccionar un tipo de sociedad") : "",
        rubro: yup.number().required("Debes seleccionar un rubro").typeError("Debes seleccionar un rubro"),
        cargo: yup.number().required("Debes ingresar un cargo").typeError("Debes ingresar un cargo")
    });
    const formik = useFormik({
        initialValues: {
            razonSocial: merchantInfo.merchantRZ,
            tipoDePersona: merchantInfo.merchantPFPJLeyenda,
            cuit: merchantInfo.merchantCUIT,
            nombre: merchantInfo.merchantNombre,
            tipoDeSociedad: merchantInfo.merchantTipoSocietarioId,
            rubro: merchantInfo.rubroMerchantId,
            cargo: merchantInfo.usuarioCargoCargoId
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setLoad(true);
            handleClickUpd({
                merchantId: merchantInfo.merchantId,
                tipoSocietarioId: values.tipoDeSociedad === null ? null : Number(values.tipoDeSociedad),
                cargoId: Number(values.cargo),
                rubroDeMerchantId: Number(values.rubro),
                estadoRegistroCod: "A"
            })
            setLoad(false);
        },
        initialErrors: {
            nombre: false
        }
    });
    const handleReadFile = async (tipo) => {
        const data = {
            fileName: `${merchantInfo.merchantCUIT.replaceAll('-', '')}_${tipo}.pdf`,
            code: tipo,
            cuit: merchantInfo.merchantCUIT.replaceAll('-', ''),
            action: "R"
        }
        const response = await MerchantBOFilesDo(credentials, data)
        if (response.status.code === 1 && response.result[0].url) {
            const { data } = await axios.get(response.result[0].url, {
                headers: {
                    'Accept': 'application/pdf',
                    "Content-Type": "application/octet-stream"
                },
                responseType: "blob",
                data: {}
            })
            let urlBlob = window.URL.createObjectURL(new Blob([data]));
            let a = document.createElement('a');
            a.href = urlBlob;
            a.download = `${merchantInfo.merchantCUIT.replaceAll('-', '')}${tipo}.pdf`; // Nombre del archivo
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

    const handleUpdFile = async (tipo) => {
        const data = {
            fileName: `${merchantInfo.merchantCUIT.replaceAll('-', '')}_${tipo}.pdf`,
            code: tipo,
            cuit: merchantInfo.merchantCUIT.replaceAll('-', ''),
            action: "U"
        }
        const response = await MerchantBOFilesDo(credentials, data)
        if (response.status.code === 1) {
            // console.log("File updated", file[0])
            await DocumentosPut(response.result[0].url, file[0])
            setUpdFile(false)
            setFile(null)
        }
    }
    return (
        <>
            {updFile ? <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "center" }}>
                <DropZone file={file} setFile={setFile} />
                <Grid item display={"flex"} flexDirection={"row"} justifyContent={"center"} alignItems={"center"} width={"100%"}>
                    <Button text={"Subir"} onClick={() => handleUpdFile(updFile)} />
                    <Button text={"Cancelar"} onClick={() => setUpdFile(false)} />
                </Grid>
            </div> : <><Grid container>
                <Identificacion formik={formik} merchantInfo={merchantInfo} />
                <Grid item md={4} lg={4} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                    <Button text={"Descargar constancia AFIP"} onClick={() => handleReadFile("AFIP")} />
                    <Button text={"Subir constancia AFIP"} onClick={() => setUpdFile("AFIP")} />
                    {merchantInfo.merchantPFPJ === "J" &&
                        <><Button text={"Descargar contrato social"} onClick={() => handleReadFile("CS")} />
                            <Button text={"Subir contrato social"} onClick={() => setUpdFile("CS")} /></>}
                </Grid>
            </Grid >
                <div>
                    <Button text={"Confirmar"} onClick={() => formik.handleSubmit()} disabled={load} />
                    <Button text={"Rechazar"} onClick={() => handleClickUpd({
                        merchantId: merchantInfo.merchantId,
                        tipoSocietarioId: formik.values.tipoDeSociedad,
                        cargoId: formik.values.cargo,
                        rubroDeMerchantId: formik.values.rubro,
                        estadoRegistroCod: "R"
                    })} disabled={load} />
                    <Button text={"Cerrar"} onClick={() => setModalDetails({ ...modalDetails, confirmationModalOpen: true })} />
                </div></>}
        </>
    )
}
